import {
  AuditLogResource,
  ListAuditLogsFilterParameterResourceTypeEq
} from "@wingspanhq/wingspan-api-sdk";
import { useMemo } from "react";

export function usePayeeHistoryResources(payeeId: string): AuditLogResource[] {
  return useMemo(
    () => [
      {
        resourceType: ListAuditLogsFilterParameterResourceTypeEq.PAYEE,
        resourceId: payeeId
      }
    ],
    [payeeId]
  );
}
